/**
 * This class is used for extracting macros in eg. status-messages in tracking. But it can also be used elsewhere.
 */
export class MacroResolver {

    private static regexDocumentId = /{DocumentId\$(\d+)}/;
    private static regexInterchangeId = /interchange with id\: (\d+),/;

    /**
     * Checks if the given text contains a macro representing a document-id. And returns the document-id if found.
     * @param textToCheck
     */
    static checkDocumentId(textToCheck: string): number {
        const value = Number(MacroResolver.resolveMacroValue(MacroResolver.regexDocumentId, textToCheck));
        return value;
    }

    static checkInterchangeId(textToCheck: string): number {
        const value = Number(MacroResolver.resolveMacroValue(MacroResolver.regexInterchangeId, textToCheck));
        return value;
    }

    static cleanDocumentId(textToClean: string): string {
        return MacroResolver.cleanMacro(MacroResolver.regexDocumentId, textToClean);
    }

    static resolveMacroValue(regex: RegExp, textToCheck: string): any {
        const result = textToCheck.match(regex);
        return (result && result.length > 1) ? result[1] : null;
    }

    static cleanMacro(regex: RegExp, textToClean: string): string {
        return textToClean.replace(regex, '');
    }
}
